<template>
    <div>
        <common-content-spacer height="medium" class="inactive-availability-list">
            <common-table>
                <thead>
                    <tr>
                        <th>{{ $t('components.availability.inactive_availability_list.performer') }}</th>
                        <th>{{ $t('components.availability.inactive_availability_list.title') }}</th>
                        <th>{{ $t('components.availability.inactive_availability_list.date') }}</th>
                        <th>{{ $t('components.availability.inactive_availability_list.offers') }}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="inactiveAvailability in inactiveAvailabilities" :key="inactiveAvailability.id">
                        <td :data-label="$t('components.availability.inactive_availability_list.performer')">
                            <div class="inactive-availability-list__user">
                                <common-user-avatar
                                    :user="performerUser(inactiveAvailability?.linkedAvailability.availabilityUsers)"
                                    size="medium-small"
                                ></common-user-avatar>
                                <span>
                                    {{ performerUser(inactiveAvailability?.linkedAvailability.availabilityUsers).firstName }}
                                    {{ performerUser(inactiveAvailability?.linkedAvailability.availabilityUsers).lastName }}
                                </span>
                            </div>
                        </td>
                        <td :data-label="$t('components.availability.inactive_availability_list.title')">
                            {{ inactiveAvailability.linkedAvailability.titleTextContent.originalText }}
                        </td>
                        <td :data-label="$t('components.availability.inactive_availability_list.date')">
                            {{ $t('common.microcopy.from') }} {{ dateFormatted(inactiveAvailability?.dateFrom) }}
                            {{ $t('common.microcopy.to') }}
                            {{ dateFormatted(inactiveAvailability?.dateTo) }}
                        </td>
                        <td
                            v-if="inactiveAvailability?.linkedOffer"
                            :data-label="$t('components.availability.inactive_availability_list.offers')"
                        >
                            {{ inactiveAvailability?.linkedOffer?.titleTextContent?.originalText }}
                        </td>
                        <td v-else :data-label="$t('components.availability.inactive_availability_list.offers')">
                            <p
                                v-for="linkedAvailabilityOffers in inactiveAvailability?.linkedAvailability
                                    .linkedAvailabilityOffers"
                                :key="linkedAvailabilityOffers.id"
                            >
                                {{ linkedAvailabilityOffers?.linkedOffer?.titleTextContent?.originalText }}
                            </p>
                        </td>
                        <td class="inactive-availability-list__last-td">
                            <common-button
                                type="primary"
                                size="tiny"
                                :isFluid="true"
                                :label="$t('common.microcopy.delete')"
                                @click="openYesNoModal(inactiveAvailability.id)"
                            ></common-button>
                        </td>
                    </tr>
                </tbody>
            </common-table>
            <slot class="inactive-availability-list__buttons"></slot>
        </common-content-spacer>
        <common-yes-no-modal
            v-if="isYesNoModalOpen"
            height="tiny"
            :showWarningIcon="true"
            :headingText="$t('modals.remove_inactivity.title')"
            :noButtonText="$t('common.microcopy.close')"
            :yesButtonText="$t('common.microcopy.delete')"
            @close="closeYesNoModal"
            @continue="deleteInactivity()"
        ></common-yes-no-modal>
    </div>
</template>

<script>
    import AvailabilityAPI from 'api/AvailabilityAPI'
    import AvailabilityUserRoleEnum from 'enums/availability_user_role.enum'

    export default {
        props: {
            inactiveAvailabilities: { type: Array, required: true },
        },

        data() {
            return {
                placeholderImage: require('../../../assets/images/no-image-placeholder.png'),
                isYesNoModalOpen: false,
                inactivityId: undefined,
            }
        },

        methods: {
            performerUser(users) {
                return users.find((u) => u.function === AvailabilityUserRoleEnum.PERFORMER).user
            },
            dateFormatted(date) {
                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            openYesNoModal(id) {
                this.inactivityId = id
                this.isYesNoModalOpen = true
            },
            closeYesNoModal() {
                this.isYesNoModalOpen = false
            },
            deleteInactivity() {
                AvailabilityAPI.deleteInactivity(this.inactivityId)
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.emitEvent({ name: 'inactivity-removed' })
                        this.closeYesNoModal()
                    })
                    .catch(() => {})
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/availability/_inactive-availability-list.scss';
</style>
